var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmoji3 = function SvgEmoji3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15.88c0 8.008-6.492 14.5-14.5 14.5C6.993 30.38.5 23.89.5 15.88.5 7.873 6.993 1.38 15 1.38c8.008 0 14.5 6.493 14.5 14.5Z",
    fill: "#fff",
    stroke: "#309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.583 17.547c1.15 0 2.084-1.306 2.084-2.917 0-1.61-.933-2.916-2.084-2.916-1.15 0-2.083 1.306-2.083 2.916 0 1.611.933 2.917 2.083 2.917ZM20.417 17.547c1.15 0 2.083-1.306 2.083-2.917 0-1.61-.933-2.916-2.083-2.916-1.151 0-2.084 1.306-2.084 2.916 0 1.611.933 2.917 2.084 2.917ZM20.833 22.547H9.167a.833.833 0 1 1 0-1.666h11.666a.833.833 0 1 1 0 1.666Z",
    fill: "#309"
  })));
};
export default SvgEmoji3;